import { call } from "redux-saga/effects";

import { dictionaryApiService } from "../../../../actionService/apiService";

import endPoints from "./contractors.endpoints";

import { ApiCallResult } from "../../../../types";

import { CreateContractorModel, UpdateContractorModel } from "../../../../../viewModels/Contractors/ContractorModel";
import ContractorDto, { ContractorType } from "../../../../../dto/Contractors/ContractorDto";
import ContractorNameInfoDto from "../../../../../dto/Settings/ContractorDto";
import { ContractorBasicInfoDto } from "../../../../../dto/Contractors/ContractorBasicInfoDto";
import type { FilterContractorsRequestDto } from "./contractors.requestsDto";
import request from "../../../../request/http-service";
import { SERVER_ADDRESSES } from "../../../../../config/serverAddressesConfig";

// The shared selector manages its own cancellable loading state outside a page's Redux slice.
export async function fetchContractorBasicInfo(id: number, host: "WEB" | "BITRIX", abortController: AbortController) {
  return (await request(
    {
      server: SERVER_ADDRESSES.DICTIONARY_API,
      controller: endPoints.basicInfo(id),
      requestMethod: "get",
      query: undefined,
      body: undefined,
      headers: undefined,
      abortController,
    },
    host,
  )) as ContractorBasicInfoDto;
}

const dictionaryContractorsApi = {
  filter: function* (dto: FilterContractorsRequestDto) {
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.filter, undefined, dto)) as ApiCallResult<{
      data: ContractorDto[];
      total: number;
    }>;
  },
  remove: function* (id: number) {
    return (yield call([dictionaryApiService, dictionaryApiService.Delete], endPoints.controller, id)) as ApiCallResult;
  },
  nameInfo: function* (contractorTypes?: ContractorType[], abortController?: AbortController) {
    return (yield call(
      [dictionaryApiService, dictionaryApiService.Get],
      endPoints.nameInfo,
      undefined,
      { contractorTypes },
      abortController,
    )) as ApiCallResult<ContractorNameInfoDto[]>;
  },

  basicInfo: function* (id: number) {
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.basicInfo(id))) as ApiCallResult<ContractorBasicInfoDto>;
  },

  update: function* ({ id, ...rest }: UpdateContractorModel) {
    return (yield call([dictionaryApiService, dictionaryApiService.Put], endPoints.controller, id, {
      ...rest,
    })) as ApiCallResult<ContractorDto>;
  },

  create: function* (model: CreateContractorModel) {
    return (yield call([dictionaryApiService, dictionaryApiService.Post], endPoints.controller, {
      ...model,
    })) as ApiCallResult<ContractorDto>;
  },
};

export default dictionaryContractorsApi;
